<template>
  <div class="code-matching">
    <div class="code-matching-title">
      {{ userInfo.name ? userInfo.name + '-' : '' }}河北商保连锁门店商品对码
      <div class="back-account-center">
        <router-link to="/myAccount">
          <el-button type="link" icon="el-icon-arrow-left"
            >返回个人中心</el-button
          >
        </router-link>
      </div>
    </div>
    <div class="code-matching-content">
      <div class="code-matching-main">
        <div class="search-content">
          <div class="wrapper">
            <el-form @keyup.enter.native="search">
              <div class="left">
                <el-input
                  class="search-input"
                  clearable
                  v-model="searchForm.id"
                  placeholder="搜索商品编码"
                ></el-input>
                <el-input
                  class="search-input"
                  clearable
                  v-model="searchForm.searchVal"
                  placeholder="搜索商品名称"
                ></el-input>
                <el-input
                  class="search-manufacturer"
                  clearable
                  v-model="searchForm.manufacturer"
                  placeholder="搜索商品生产商家"
                ></el-input>
                <!-- <el-tooltip
                effect="dark"
                content="请选择商品关联匹配状态"
                placement="top"
              >
                <el-select
                  v-model="searchForm.mapFlag"
                  placeholder="请选择匹配状态"
                >
                  <el-option
                    v-for="item in mapFlagOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option> </el-select
              ></el-tooltip> -->
                <el-tooltip
                  effect="dark"
                  content="请选择商品关联匹配方式"
                  placement="top"
                >
                  <el-select
                    v-model="searchForm.mapType"
                    placeholder="请选择匹配方式"
                  >
                    <el-option
                      v-for="item in mapTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-tooltip>
                <el-tooltip
                  effect="dark"
                  content="请选择门店库存状态"
                  placement="top"
                >
                  <el-select
                    v-model="searchForm.inventoryFlag"
                    placeholder="请选择库存状态"
                  >
                    <el-option
                      v-for="item in inventoryFlagOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-tooltip>
                <el-input
                  class="search-input"
                  v-model="searchForm.barCode"
                  clearable
                  placeholder="搜索商品条形码"
                ></el-input>
                <el-button
                  class="search-btn"
                  type="primary"
                  icon="el-icon-search"
                  @click="search"
                  >搜索店铺商品</el-button
                >
                <el-button
                  class="search-btn"
                  type="danger"
                  icon="el-icon-reload"
                  @click="resetSearch"
                  >重置搜索条件</el-button
                >
              </div>
            </el-form>
          </div>
          <div class="wrapper" style="padding-top: 10px">
            <div class="right">
              <el-button
                @click="showExcelImportModal"
                type="primary"
                icon="el-icon-upload2"
                >Excel导入商品表</el-button
              >
              <!-- <el-button @click="openNewWindow('/chain/goodsDetail')" type="primary"
                >新增门店商品</el-button
              >
              <el-button @click="batchDelete" type="danger" plain
                >批量删除</el-button
              > -->
              <el-dropdown trigger="click">
                <el-button class="dropdown-btn" type="primary" plain>
                  更多功能
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <!-- <el-dropdown-item>查看已对码记录</el-dropdown-item> -->

                  <router-link to="/chain/lsGoodsList">
                    <el-dropdown-item
                      >查看总部商品表</el-dropdown-item
                    ></router-link
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <el-button
                type="primary"
                @click="exportExcel"
                icon="el-icon-download"
                >导出</el-button
              >
            </div>
          </div>
        </div>
        <div class="table-content">
          <el-tabs
            style="padding: 0 30px"
            v-model="searchForm.group"
            @tab-click="handleClick"
          >
            <el-tab-pane
              v-for="(item, index) of groupList"
              :key="index"
              :label="item.k1"
              :name="item.k1"
            >
              <span slot="label"
                >{{ item.k1 }} <span class="badge">{{ item.v1 }}</span></span
              >

              <el-table
                v-show="item.k1 === '全部'"
                v-loading="loading"
                ref="multipleTable"
                :border="true"
                :stripe="true"
                :data="tableData"
                style="width: 100%"
                size="mini"
                height="calc(100vh - 358px)"
                highlight-current-row
                @current-change="tableCurrentChange"
                :current-row-key="currentRowKey"
              >
                <!-- <el-table-column
                  style="padding-left: 10px"
                  type="selection"
                  width="55"
                ></el-table-column> -->
                <el-table-column
                  align="center"
                  width="100"
                  prop="mapFlag"
                  label="匹配状态"
                >
                  <template slot-scope="scope">
                    <el-tag
                      style="
                        font-size: 12px;
                        border-radius: 10px;
                        padding: 0 8px;
                        cursor: pointer;
                      "
                      size="mini"
                      :type="scope.row.mapFlag === '1' ? 'success' : 'danger'"
                      effect="dark"
                      >{{
                        scope.row.mapFlag === "1" ? "已匹配" : "未匹配"
                      }}</el-tag
                    >
                  </template> </el-table-column
                ><el-table-column width="120" prop="id" label="商品编码">
                </el-table-column>

                <el-table-column prop="otherName" label="门店商品信息">
                  <template slot-scope="scope">
                    <p class="product-text">商品名称：{{ scope.row.name }}</p>
                    <p class="product-text">
                      生产厂家：{{ scope.row.manufacturer }}
                    </p>
                    <p class="product-text">规格：{{ scope.row.format }}</p>
                    <p class="product-text">单位：{{ scope.row.unit }}</p>
                    <p class="product-text">剂型：{{ scope.row.dosageForm }}</p>
                    <p class="product-text">
                      批准文号：{{ scope.row.license }}
                    </p>
                    <p class="product-text">条码：{{ scope.row.barCode }}</p>
                  </template>
                </el-table-column>
                <el-table-column prop="index" label="连锁总部商品信息">
                  <template slot-scope="scope">
                    <p class="product-text">
                      商品名称：<span
                        :style="`color: ${
                          scope.row.liansuoProductName === scope.row.name
                            ? '#409eff'
                            : '#F56C6C'
                        }`"
                        >{{ scope.row.liansuoProductName }}</span
                      >
                    </p>
                    <p class="product-text">
                      生产厂家：<span
                        :style="`color: ${
                          scope.row.liansuoManufacturer ===
                          scope.row.manufacturer
                            ? '#409eff'
                            : '#F56C6C'
                        }`"
                      >
                        {{ scope.row.liansuoManufacturer }}
                      </span>
                    </p>
                    <p class="product-text">
                      规格：<span
                        :style="`color: ${
                          scope.row.liansuoFormat === scope.row.format
                            ? '#409eff'
                            : '#F56C6C'
                        }`"
                      >
                        {{ scope.row.liansuoFormat }}
                      </span>
                    </p>
                    <p class="product-text">
                      单位：<span
                        :style="`color: ${
                          scope.row.liansuoUnit === scope.row.unit
                            ? '#409eff'
                            : '#F56C6C'
                        }`"
                      >
                        {{ scope.row.liansuoUnit }}
                      </span>
                    </p>
                    
                    <p class="product-text">
                      剂型：<span
                        :style="`color: ${
                          scope.row.liansuoDosageForm === scope.row.dosageForm
                            ? '#409eff'
                            : '#F56C6C'
                        }`"
                      >
                        {{ scope.row.liansuoDosageForm }}
                      </span>
                    </p>
                    <p class="product-text">
                      批准文号：<span
                        :style="`color: ${
                          scope.row.liansuoLicense === scope.row.license
                            ? '#409eff'
                            : '#F56C6C'
                        }`"
                        >{{ scope.row.liansuoLicense }}</span
                      >
                    </p>
                    <p class="product-text">
                      条码：<span
                        :style="`color: ${
                          scope.row.liansuoBarCode === scope.row.barCode
                            ? '#409eff'
                            : '#F56C6C'
                        }`"
                        >{{ scope.row.liansuoBarCode }}</span
                      >
                    </p>
                  </template>
                </el-table-column>
                <el-table-column prop="updateTime" label="匹配时间">
                </el-table-column>
                <el-table-column width="80" prop="mapInfo" label="匹配条件">
                </el-table-column>
                <el-table-column
                  align="center"
                  width="120"
                  prop="mapType"
                  label="匹配方式"
                >
                  <template slot-scope="scope">
                    <el-tag
                      v-if="scope.row.mapFlag === '1'"
                      style="
                        font-size: 12px;
                        border-radius: 10px;
                        padding: 0 8px;
                        cursor: pointer;
                      "
                      size="mini"
                      :type="
                        scope.row.mapType === '手动' ? 'success' : 'warning'
                      "
                      effect="dark"
                      >{{
                        scope.row.mapType === "手动" ? "手动匹配" : "自动匹配"
                      }}</el-tag
                    >
                  </template>
                </el-table-column>
                <el-table-column width="80" prop="unit" label="单位">
                </el-table-column>
                <el-table-column width="80" prop="dosageForm" label="剂型">
                </el-table-column>
                <el-table-column
                  width="150"
                  prop="inventory"
                  label="门店本地ERP库存"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.inventory }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  width="150"
                  prop="mendianInventory"
                  label="连锁门店ERP库存"
                >
                  <template slot-scope="scope">
                    <span :style="scope.row.inventory !== scope.row.mendianInventory ? 'color:#f78989' : ''">{{ scope.row.mendianInventory }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作区" width="150">
                  <template slot-scope="scope">
                    <el-button
                      style="color: #409eff"
                      @click.native.prevent="showMatchProductsModal(scope.row)"
                      type="text"
                      size="small"
                    >
                      {{ scope.row.mapFlag === "1" ? "修改匹配" : "关联匹配" }}
                    </el-button>
                    <el-button
                      style="color: #18a97b"
                      @click.native.prevent="editGoodsData(scope.row)"
                      type="text"
                      size="small"
                    >
                      编辑
                    </el-button>
                    <!-- <el-button
                      style="color: #f56c6c"
                      @click.native.prevent="deleteRow(scope.row.id)"
                      type="text"
                      size="small"
                    >
                      删除
                    </el-button> -->
                  </template>
                </el-table-column>
              </el-table>
              <el-table
                v-show="item.k1 === '匹配完成'"
                v-loading="loading"
                ref="multipleTable"
                :border="true"
                :stripe="true"
                :data="tableData"
                style="width: 100%"
                size="mini"
                height="calc(100vh - 358px)"
                highlight-current-row
                @current-change="tableCurrentChange"
                :current-row-key="currentRowKey"
              >
                <!-- <el-table-column
                  style="padding-left: 10px"
                  type="selection"
                  width="55"
                ></el-table-column> -->
                <el-table-column width="120" prop="id" label="商品编码">
                </el-table-column>
                <el-table-column
                  align="center"
                  width="100"
                  prop="mapFlag"
                  label="匹配状态"
                >
                  <template slot-scope="scope">
                    <el-tag
                      style="
                        font-size: 12px;
                        border-radius: 10px;
                        padding: 0 8px;
                        cursor: pointer;
                      "
                      size="mini"
                      :type="scope.row.mapFlag === '1' ? 'success' : 'danger'"
                      effect="dark"
                      >{{
                        scope.row.mapFlag === "1" ? "已匹配" : "未匹配"
                      }}</el-tag
                    >
                  </template>
                </el-table-column>
                <el-table-column prop="otherName" label="门店商品信息">
                  <template slot-scope="scope">
                    <p class="product-text">商品名称：{{ scope.row.name }}</p>
                    <p class="product-text">
                      生产厂家：{{ scope.row.manufacturer }}
                    </p>
                    <p class="product-text">规格：{{ scope.row.format }}</p>
                    <p class="product-text">单位：{{ scope.row.unit }}</p>
                    <p class="product-text">剂型：{{ scope.row.dosageForm }}</p>
                    <p class="product-text">
                      批准文号：{{ scope.row.license }}
                    </p>
                    <p class="product-text">条码：{{ scope.row.barCode }}</p>
                  </template>
                </el-table-column>
                <el-table-column prop="index" label="连锁总部商品信息">
                  <template slot-scope="scope">
                    <p class="product-text">
                      商品名称：<span
                        :style="`color: ${
                          scope.row.liansuoProductName === scope.row.name
                            ? '#409eff'
                            : '#F56C6C'
                        }`"
                        >{{ scope.row.liansuoProductName }}</span
                      >
                    </p>
                    <p class="product-text">
                      生产厂家：<span
                        :style="`color: ${
                          scope.row.liansuoManufacturer ===
                          scope.row.manufacturer
                            ? '#409eff'
                            : '#F56C6C'
                        }`"
                      >
                        {{ scope.row.liansuoManufacturer }}
                      </span>
                    </p>
                    <p class="product-text">
                      规格：<span
                        :style="`color: ${
                          scope.row.liansuoFormat === scope.row.format
                            ? '#409eff'
                            : '#F56C6C'
                        }`"
                      >
                        {{ scope.row.liansuoFormat }}
                      </span>
                    </p>
                    <p class="product-text">
                      单位：<span
                        :style="`color: ${
                          scope.row.liansuoUnit === scope.row.unit
                            ? '#409eff'
                            : '#F56C6C'
                        }`"
                      >
                        {{ scope.row.liansuoUnit }}
                      </span>
                    </p>
                    
                    <p class="product-text">
                      剂型：<span
                        :style="`color: ${
                          scope.row.liansuoDosageForm === scope.row.dosageForm
                            ? '#409eff'
                            : '#F56C6C'
                        }`"
                      >
                        {{ scope.row.liansuoDosageForm }}
                      </span>
                    </p>
                    <p class="product-text">
                      批准文号：<span
                        :style="`color: ${
                          scope.row.liansuoLicense === scope.row.license
                            ? '#409eff'
                            : '#F56C6C'
                        }`"
                        >{{ scope.row.liansuoLicense }}</span
                      >
                    </p>
                    <p class="product-text">
                      条码：<span
                        :style="`color: ${
                          scope.row.liansuoBarCode === scope.row.barCode
                            ? '#409eff'
                            : '#F56C6C'
                        }`"
                        >{{ scope.row.liansuoBarCode }}</span
                      >
                    </p>
                  </template>
                </el-table-column>
                <el-table-column prop="updateTime" label="匹配时间">
                </el-table-column>
                <el-table-column width="80" prop="mapInfo" label="匹配条件">
                </el-table-column>
                <el-table-column
                  align="center"
                  width="120"
                  prop="mapType"
                  label="匹配方式"
                >
                  <template slot-scope="scope">
                    <el-tag
                      v-if="scope.row.mapFlag === '1'"
                      style="
                        font-size: 12px;
                        border-radius: 10px;
                        padding: 0 8px;
                        cursor: pointer;
                      "
                      size="mini"
                      :type="
                        scope.row.mapType === '手动' ? 'success' : 'warning'
                      "
                      effect="dark"
                      >{{
                        scope.row.mapType === "手动" ? "手动匹配" : "自动匹配"
                      }}</el-tag
                    >
                  </template>
                </el-table-column>
                
                <el-table-column
                  width="150"
                  prop="inventory"
                  label="门店本地ERP库存"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.inventory }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  width="150"
                  prop="mendianInventory"
                  label="连锁门店ERP库存"
                >
                  <template slot-scope="scope">
                    <span :style="scope.row.inventory !== scope.row.mendianInventory ? 'color:#f78989' : ''">{{ scope.row.mendianInventory }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作区" width="150">
                  <template slot-scope="scope">
                    <el-button
                      style="color: #409eff"
                      @click.native.prevent="showMatchProductsModal(scope.row)"
                      type="text"
                      size="small"
                    >
                      {{ scope.row.mapFlag === "1" ? "修改匹配" : "关联匹配" }}
                    </el-button>
                    <el-button
                      style="color: #18a97b"
                      @click.native.prevent="editGoodsData(scope.row)"
                      type="text"
                      size="small"
                    >
                      编辑
                    </el-button>
                    <!-- <el-button
                      style="color: #f56c6c"
                      @click.native.prevent="deleteRow(scope.row.id)"
                      type="text"
                      size="small"
                    >
                      删除
                    </el-button> -->
                  </template>
                </el-table-column>
              </el-table>
              <el-table
                v-show="item.k1 === '未匹配'"
                v-loading="loading"
                ref="multipleTable"
                :border="true"
                :stripe="true"
                :data="tableData"
                style="width: 100%"
                size="mini"
                height="calc(100vh - 358px)"
                highlight-current-row
                @current-change="tableCurrentChange"
                :current-row-key="currentRowKey"
              >
                <!-- <el-table-column
                  style="padding-left: 10px"
                  type="selection"
                  width="55"
                ></el-table-column> -->
                <el-table-column
                  align="center"
                  width="100"
                  prop="mapFlag"
                  label="匹配状态"
                >
                  <template slot-scope="scope">
                    <el-tag
                      style="
                        font-size: 12px;
                        border-radius: 10px;
                        padding: 0 8px;
                        cursor: pointer;
                      "
                      size="mini"
                      :type="scope.row.mapFlag === '1' ? 'success' : 'danger'"
                      effect="dark"
                      >{{
                        scope.row.mapFlag === "1" ? "已匹配" : "未匹配"
                      }}</el-tag
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  width="120"
                  prop="id"
                  label="商品编码"
                ></el-table-column>
                <el-table-column prop="otherName" label="门店商品信息">
                  <template slot-scope="scope">
                    <p class="product-text">商品名称：{{ scope.row.name }}</p>
                    <p class="product-text">
                      生产厂家：{{ scope.row.manufacturer }}
                    </p>
                    <p class="product-text">规格：{{ scope.row.format }}</p>
                    <p class="product-text">单位：{{ scope.row.unit }}</p>
                    <p class="product-text">剂型：{{ scope.row.dosageForm }}</p>
                    <p class="product-text">
                      批准文号：{{ scope.row.license }}
                    </p>
                    <p class="product-text">条码：{{ scope.row.barCode }}</p>
                  </template>
                </el-table-column>
                <el-table-column prop="index" label="连锁总部商品信息">
                  <template slot-scope="scope">
                    <p class="product-text">
                      商品名称：<span
                        :style="`color: ${
                          scope.row.liansuoProductName === scope.row.name
                            ? '#409eff'
                            : '#F56C6C'
                        }`"
                        >{{ scope.row.liansuoProductName }}</span
                      >
                    </p>
                    <p class="product-text">
                      生产厂家：<span
                        :style="`color: ${
                          scope.row.liansuoManufacturer ===
                          scope.row.manufacturer
                            ? '#409eff'
                            : '#F56C6C'
                        }`"
                      >
                        {{ scope.row.liansuoManufacturer }}
                      </span>
                    </p>
                    <p class="product-text">
                      规格：<span
                        :style="`color: ${
                          scope.row.liansuoFormat === scope.row.format
                            ? '#409eff'
                            : '#F56C6C'
                        }`"
                      >
                        {{ scope.row.liansuoFormat }}
                      </span>
                    </p>
                    <p class="product-text">
                      单位：<span
                        :style="`color: ${
                          scope.row.liansuoUnit === scope.row.unit
                            ? '#409eff'
                            : '#F56C6C'
                        }`"
                      >
                        {{ scope.row.liansuoUnit }}
                      </span>
                    </p>
                    
                    <p class="product-text">
                      剂型：<span
                        :style="`color: ${
                          scope.row.liansuoDosageForm === scope.row.dosageForm
                            ? '#409eff'
                            : '#F56C6C'
                        }`"
                      >
                        {{ scope.row.liansuoDosageForm }}
                      </span>
                    </p>
                    <p class="product-text">
                      批准文号：<span
                        :style="`color: ${
                          scope.row.liansuoLicense === scope.row.license
                            ? '#409eff'
                            : '#F56C6C'
                        }`"
                        >{{ scope.row.liansuoLicense }}</span
                      >
                    </p>
                    <p class="product-text">
                      条码：<span
                        :style="`color: ${
                          scope.row.liansuoBarCode === scope.row.barCode
                            ? '#409eff'
                            : '#F56C6C'
                        }`"
                        >{{ scope.row.liansuoBarCode }}</span
                      >
                    </p>
                  </template>
                </el-table-column>
                <el-table-column prop="updateTime" label="匹配时间">
                </el-table-column>
                <el-table-column width="80" prop="mapInfo" label="匹配条件">
                </el-table-column>
                <el-table-column
                  align="center"
                  width="120"
                  prop="mapType"
                  label="匹配方式"
                >
                  <template slot-scope="scope">
                    <el-tag
                      v-if="scope.row.mapFlag === '1'"
                      style="
                        font-size: 12px;
                        border-radius: 10px;
                        padding: 0 8px;
                        cursor: pointer;
                      "
                      size="mini"
                      :type="
                        scope.row.mapType === '手动' ? 'success' : 'warning'
                      "
                      effect="dark"
                      >{{
                        scope.row.mapType === "手动" ? "手动匹配" : "自动匹配"
                      }}</el-tag
                    >
                  </template>
                </el-table-column>
                <el-table-column width="80" prop="unit" label="单位">
                </el-table-column>
                <el-table-column width="80" prop="dosageForm" label="剂型">
                </el-table-column>
                
                <el-table-column
                  width="150"
                  prop="inventory"
                  label="门店本地ERP库存"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.inventory }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  width="150"
                  prop="mendianInventory"
                  label="连锁门店ERP库存"
                >
                  <template slot-scope="scope">
                    <span :style="scope.row.inventory !== scope.row.mendianInventory ? 'color:#f78989' : ''">{{ scope.row.mendianInventory }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作区" width="150">
                  <template slot-scope="scope">
                    <el-button
                      style="color: #409eff"
                      @click.native.prevent="showMatchProductsModal(scope.row)"
                      type="text"
                      size="small"
                    >
                      {{ scope.row.mapFlag === "1" ? "修改匹配" : "关联匹配" }}
                    </el-button>
                    <el-button
                      style="color: #18a97b"
                      @click.native.prevent="editGoodsData(scope.row)"
                      type="text"
                      size="small"
                    >
                      编辑
                    </el-button>
                    <!-- <el-button
                      style="color: #f56c6c"
                      @click.native.prevent="deleteRow(scope.row.id)"
                      type="text"
                      size="small"
                    >
                      删除
                    </el-button> -->
                  </template>
                </el-table-column>
              </el-table>
              <el-table
                v-show="item.k1 === '待确认'"
                v-loading="loading"
                ref="multipleTable"
                :border="true"
                :stripe="true"
                :data="tableData"
                style="width: 100%"
                size="mini"
                height="calc(100vh - 358px)"
              >
                <el-table-column
                  style="padding-left: 10px"
                  type="index"
                  align="center"
                  label="序号"
                  width="80"
                ></el-table-column>
                <el-table-column
                  width="120"
                  prop="id"
                  label="商品编码"
                ></el-table-column>

                <el-table-column prop="otherName" label="门店商品信息">
                  <template slot-scope="scope">
                    <p class="product-text">商品名称：{{ scope.row.name }}</p>
                    <p class="product-text">
                      生产厂家：{{ scope.row.manufacturer }}
                    </p>
                    <p class="product-text">规格：{{ scope.row.format }}</p>
                    <p class="product-text">单位：{{ scope.row.unit }}</p>
                    <p class="product-text">剂型：{{ scope.row.dosageForm }}</p>
                    <p class="product-text">
                      批准文号：{{ scope.row.license }}
                    </p>
                    <p class="product-text">条码：{{ scope.row.barCode }}</p>
                  </template>
                </el-table-column>
                <el-table-column prop="index" label="连锁总部商品信息">
                  <template slot-scope="scope">
                    <p class="product-text">
                      商品名称：<span
                        :style="`color: ${
                          scope.row.liansuoProductName === scope.row.name
                            ? '#409eff'
                            : '#F56C6C'
                        }`"
                        >{{ scope.row.liansuoProductName }}</span
                      >
                    </p>
                    <p class="product-text">
                      生产厂家：<span
                        :style="`color: ${
                          scope.row.liansuoManufacturer ===
                          scope.row.manufacturer
                            ? '#409eff'
                            : '#F56C6C'
                        }`"
                      >
                        {{ scope.row.liansuoManufacturer }}
                      </span>
                    </p>
                    <p class="product-text">
                      规格：<span
                        :style="`color: ${
                          scope.row.liansuoFormat === scope.row.format
                            ? '#409eff'
                            : '#F56C6C'
                        }`"
                      >
                        {{ scope.row.liansuoFormat }}
                      </span>
                    </p>
                    <p class="product-text">
                      单位：<span
                        :style="`color: ${
                          scope.row.liansuoUnit === scope.row.unit
                            ? '#409eff'
                            : '#F56C6C'
                        }`"
                      >
                        {{ scope.row.liansuoUnit }}
                      </span>
                    </p>
                    
                    <p class="product-text">
                      剂型：<span
                        :style="`color: ${
                          scope.row.liansuoDosageForm === scope.row.dosageForm
                            ? '#409eff'
                            : '#F56C6C'
                        }`"
                      >
                        {{ scope.row.liansuoDosageForm }}
                      </span>
                    </p>
                    <p class="product-text">
                      批准文号：<span
                        :style="`color: ${
                          scope.row.liansuoLicense === scope.row.license
                            ? '#409eff'
                            : '#F56C6C'
                        }`"
                        >{{ scope.row.liansuoLicense }}</span
                      >
                    </p>
                    <p class="product-text">
                      条码：<span
                        :style="`color: ${
                          scope.row.liansuoBarCode === scope.row.barCode
                            ? '#409eff'
                            : '#F56C6C'
                        }`"
                        >{{ scope.row.liansuoBarCode }}</span
                      >
                    </p>
                  </template>
                </el-table-column>
                <el-table-column prop="updateTime" label="匹配时间">
                </el-table-column>
                <el-table-column align="center" prop="mapType" label="匹配方式">
                  <template slot-scope="scope">
                    <el-tag
                      v-if="scope.row.mapFlag === '1'"
                      style="
                        font-size: 12px;
                        border-radius: 10px;
                        padding: 0 8px;
                        cursor: pointer;
                      "
                      size="mini"
                      :type="
                        scope.row.mapType === '手动' ? 'success' : 'warning'
                      "
                      effect="dark"
                      >{{
                        scope.row.mapType === "手动" ? "手动匹配" : "自动匹配"
                      }}</el-tag
                    >
                  </template>
                </el-table-column>
                <el-table-column prop="mapInfo" label="匹配规则">
                </el-table-column>
                <el-table-column width="100" label="操作区">
                  <template slot-scope="scope">
                    <el-button
                      style="color: #409eff"
                      @click.native.prevent="auditMatch(scope.row)"
                      type="text"
                      size="small"
                    >
                      审批关联
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
          <div class="bottom-page-content">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageNo"
              :page-sizes="[20, 30, 40, 50]"
              layout=" sizes,prev,pager, next,total"
              :total="totalCount"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <match-products-modal ref="matchProductsModal" @refresh="loadData()" />
    <add-goods-modal @uploadSuccess="uploadSuccess" ref="addGoodsModal" />
  </div>
</template>

<script>
import { deleteAction, downFile, getAction, putAction } from "../../api/manage";
import { getUserInfo } from '../../assets/js/common/common';
import AddGoodsModal from "./modules/AddGoodsModal.vue";
import MatchProductsModal from "./modules/MatchProductsModal.vue";
export default {
  components: { AddGoodsModal, MatchProductsModal },
  data() {
    return {
      groupList: [],
      loading: false,
      totalCount: 0,
      pageNo: 1,
      pageSize: 20,
      searchForm: {
        searchVal: "",
        manufacturer: "",
        barCode: "",
        mapType: "",
        mapFlag: "",
        inventoryFlag: "1",
        group: "未匹配",
      },
      mapFlagOptions: [
        { value: "", label: "全部" },
        { value: "1", label: "已匹配" },
        { value: "0", label: "未匹配" },
      ],
      mapTypeOptions: [
        { value: "", label: "全部" },
        { value: "手动", label: "手动匹配" },
        { value: "自动", label: "自动匹配" },
      ],
      inventoryFlagOptions: [
        { value: "", label: "全部" },
        { value: "1", label: "有库存" },
        { value: "0", label: "无库存" },
      ],
      tableData: [], // 门店商品列表
      multipleSelection: [],
      currentRow: null,
      userInfo: {},
      currentRowKey: "id", // 假设每行数据都有一个唯一的 id 字段
    };
  },
  created() {
    let userInfo = getUserInfo();
    console.log("当前登录的用户信息为", userInfo)
    if(userInfo && userInfo !== '') {
      this.userInfo = userInfo;
    }
    let group = localStorage.getItem("group");
    if (group && group !== "") {
      this.searchForm.group = group;
    }
    this.loadData(1);
  },
  methods: {
    openNewWindow(path, query) {
      const routeData = this.$router.resolve({ path: path, query: query });
      console.log("routeData+++++++++++", routeData);
      window.open(routeData.href, "_blank");
    },
    // addGoodsRoute() {
    //   this.$router.push({ path: "/chain/goodsDetail" });
    // },
    auditMatch(item) {
      this.$confirm("确定审批关联？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        // 关联商品
        let url = "/liansuo/productMendian/mendian/edit";
        let params = {
          id: item.id,
          status: "1",
        };
        putAction(url, params).then((res) => {
          console.log("关联商品返回的数据为", res);
          if (res.code === 200 && res.success) {
            this.$message({
              message: "审批成功！",
              offset: 400,
              duration: 1000,
              type: "success",
            });
            this.loadData(1);
          }
        });
        console.log("确认关联的数据为", params);
      });
    },
    handleClick(val) {
      let group = val.name;
      this.searchForm.group = group;
      localStorage.setItem("group", group);
      console.log("当前选择的筛选状态", group);
      this.loadData(1);
    },
    exportExcel({ fileName = "门店商品导出表" }) {
      let url = "/liansuo/productMendian/mendian/exportXls";
      downFile(url, this.searchForm).then((data) => {
        console.log("导出数据", data);
        if (!data) {
          this.$message.warning("文件下载失败");
          return;
        }
        if (typeof window.navigator.msSaveBlob !== "undefined") {
          window.navigator.msSaveBlob(new Blob([data]), fileName + ".xls");
        } else {
          let url = window.URL.createObjectURL(new Blob([data]));
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", fileName + ".xls");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      });
    },
    batchDelete() {
      let seletecdRow = this.multipleSelection;
      let ids = [];
      seletecdRow.forEach((item) => {
        ids.push(item.id);
      });
      if (ids.length === 0) {
        this.$message({
          type: "warning",
          message: "请选择要删除的数据！",
        });
        return;
      }
      this.$confirm("确定要删除选中的数据吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let url = "/liansuo/productMendian/mendian/deleteBatch";
          let idsStr = ids.toString();
          deleteAction(url, {
            ids: idsStr,
          }).then((res) => {
            console.log("批量删除商品列表数据为", ids);
            if (res.code === 200 && res.success) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.loadData(1);
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          });
          return;
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: "批量删除操作失败",
          });
        });
    },
    tableCurrentChange(val) {
      this.currentRow = val;
    },
    // 点击关联匹配
    showMatchProductsModal(item) {
      this.$refs.matchProductsModal.showModal(item);
    },
    // 修改本地商品库数据
    editGoodsData(item) {
      // this.$router.push({
      //   path: "/chain/goodsDetail",
      //   query: { id: item.id, opreateType: "1" },
      // });
      this.openNewWindow("/chain/goodsDetail", {
        id: item.id,
        opreateType: "1",
      });
    },
    // 确认匹配
    confirmMatch() {},
    toggleSelection(rows) {
      console.log("点击选中的复选框事件", rows);
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    search() {
      this.searchForm.group = "未匹配";
      let group = localStorage.getItem("group");
      console.log("group++++++++", group);
      if (group && group !== "") {
        localStorage.removeItem("group");
      }
      this.loadData(1);
    },
    resetSearch() {
      this.searchForm = {
        searchVal: "",
        manufacturer: "",
        barCode: "",
        mapType: "",
        mapFlag: "",
        inventoryFlag: "1",
        status: "",
        group: "未匹配",
      };
      this.group = "1";
      this.loadData(1);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      let pageNo = this.pageNo;
      this.loadData(pageNo);
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.loadData(val);
    },
    // 上传成功
    uploadSuccess() {
      this.loadData(1);
    },
    loadData(page) {
      let _this = this;
      this.loading = true;
      let url = "/liansuo/productMendian/mendian/listNew";
      let pageSize = this.pageSize;
      let data = {
        ...this.searchForm,
        pageNo: page,
        pageSize: pageSize,
      };
      getAction(url, data).then((res) => {
        _this.loading = false;
        if (res.code === 200 && res.success) {
          _this.groupList = res.result.groupList;
          _this.tableData = res.result.list.records;
          console.log("商品列表数据为", _this.tableData);
          _this.totalCount = res.result.list.total;
        }
      });
    },
    showExcelImportModal() {
      this.$refs.addGoodsModal.showExcelImportModal();
    },
    deleteRow(id) {
      this.$confirm("该操作会删除门店该商品数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = { id: id };
          let url = "/liansuo/productMendian/mendian/delete";
          deleteAction(url, params).then((res) => {
            if (res.code === 200 && res.success) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.loadData(1);
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: "删除操作失败",
          });
        });
    },
  },
  mounted() {
    let openExcel = this.$route.query.openExcel;
    if (openExcel) {
      this.showExcelImportModal();
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__headerbtn .el-dialog__close {
  font-size: 18px;
}
* {
  font-size: 14px;
}
.code-matching {
  height: 100%;
}

.code-matching-title {
  display: flex;
  height: 60px;
  background-color: #24263d;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  letter-spacing: 2px;
  font-weight: bold;
  color: #ffffff;
  position: relative;
  .back-account-center {
    position: absolute;
    left: 20px;
  }
}
.dropdown-btn {
  color: #409eff !important;
  background: #ecf5ff !important;
}
.code-matching-content {
  padding: 10px 10px;
  background-color: #ecedf2;
  height: calc(100% - 60px);
  .search-content {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    background-color: #fff;
    padding: 20px;
    .wrapper {
      width: 100%;
      .left {
        width: 100%;
        .el-input {
          width: 180px;
          min-width: 150px;
          margin-bottom: 10px;
          &.search-manufacturer {
            width: 200px;
          }
        }
        ::v-deep .el-input__inner {
          border-radius: 5px !important;
        }
        .el-select {
          min-width: 100px;
          width: 150px;
          margin-left: 10px;
          margin-bottom: 10px;
        }
        .search-input {
          padding: 0 10px;
          border-radius: 5px;
        }
        .search-btn {
          margin-left: 10px;
          margin-bottom: 10px;
        }
      }
      .right {
        .el-button {
          margin-left: 10px;
          margin-bottom: 10px;
        }

        .dropdown-btn {
          color: #409eff !important;
          background: #ecf5ff !important;
          border-color: #409eff !important;
          &:hover {
            background-color: #409eff !important;
            color: #ffffff !important;
          }
        }
      }
    }
  }
  ::v-deep .el-table th.el-table__cell {
    overflow: hidden;
    user-select: none;
    background-color: #f6f7fa !important;
  }
}
.table-content {
  background-color: #ffffff;
  .bottom-page-content {
    padding: 20px;
    display: flex;
    justify-content: flex-end;
    .opreate-btn {
      display: flex;
      div {
        width: 30px;
        height: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: justify;
        margin-right: 10px;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }
      }
    }
    ::v-deep .el-pagination__total {
      line-height: 28px !important;
    }
  }
}
::v-deep .el-table-column--selection {
  .el-checkbox {
    padding-left: 10px;
  }
}
/* 全局样式文件，例如 main.css */
::-webkit-scrollbar {
  width: 6px; /* 滚动条宽度 */
}
::-webkit-scrollbar-track {
  background: #f1f1f1; /* 滚动条轨道背景色 */
}

::-webkit-scrollbar-thumb {
  background: #888; /* 滚动条滑块背景色 */
  border-radius: 3px; /* 滑块圆角 */
}

.el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  background: #555; /* 滑块悬停时背景色 */
}
// ::v-deep .el-table__body-wrapper, ::v-deep .el-scrollbar__wrap {
//   &::-webkit-scrollbar {
//     width: 6px;
//     height: 6px;
//   }
// }
::v-deep .el-input {
  .el-input__clear {
    padding-right: 15px !important;
  }
}
.badge {
  background-color: red;
  color: white;
  border-radius: 50%; /* 使其成为圆形 */
  padding: 2px 5px;
  margin-left: 5px; /* 距离标签的距离 */
  position: relative;
  top: -10px; /* 调整到合适的位置 */
  font-size: 12px;
}
</style>